var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5075 5.99604e-07C52.0308 0.00345795 67.0092 14.9957 67 33.5225C66.9896 52.04 51.979 67.023 33.4614 67C14.9346 66.9758 -0.0276205 51.9732 3.82852e-05 33.4464C0.0276971 14.945 15.0026 -0.00345675 33.5075 5.99604e-07ZM26.6516 38.2959C26.4165 37.9628 26.3151 37.7681 26.1676 37.6194C23.3798 34.8213 20.5886 32.0266 17.7939 29.2342C17.1473 28.5877 16.6656 28.5854 16.0214 29.2284C14.2167 31.0309 12.4165 32.8368 10.6176 34.6438C9.95951 35.3053 9.96297 35.8009 10.6233 36.4647C15.6307 41.4905 20.6393 46.5152 25.6478 51.5399C26.36 52.2544 26.8452 52.2567 27.5517 51.5491C37.155 41.9261 46.7572 32.3032 56.3594 22.6791C57.0774 21.9588 57.0751 21.5059 56.3514 20.7798C54.6457 19.0684 52.9378 17.3594 51.231 15.6503C50.3068 14.7249 49.9564 14.7214 49.0483 15.6318C41.7498 22.9487 34.4502 30.2656 27.1552 37.5871C26.995 37.7473 26.8878 37.9594 26.6504 38.2959H26.6516Z",
    fill: "url(#paint0_linear_1_1931)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1931",
    x1: 33.3771,
    y1: -10.8216,
    x2: 33.4493,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/book-icon.e5b81f4590d55f938768a7f54ce2458c.svg";
export { ForwardRef as ReactComponent };